import React from 'react';
import Link from 'next/link';
import { Switch } from '@headlessui/react';
import { useRouter } from 'next/router';

const FreeCollectionsSwitch: React.FC<any> = (props) => {
  const router = useRouter();
  return (
    <div className="flex items-center justify-center text-white-60 text-[14px] font-normal gap-4 mb-8 absolute top-8 w-full px-8">
      <Link
        href="/collections/free-vfx/category"
        className={
          !router.pathname.includes('free-for-subscribers') ? 'text-a-blue font-medium' : ''
        }
      >
        Free for Everyone
      </Link>
      <Link href="/collections/free-vfx/category">
        <Switch
          checked={router.pathname.includes('free-for-subscribers')}
          onClick={() => {
            if (router.pathname.includes('free-for-subscribers')) {
              window.location.href = '/collections/free-vfx/category';
            } else {
              window.location.href = '/collections/free-for-subscribers';
            }
          }}
          className={`bg-white relative inline-flex h-6 w-11 items-center rounded-full`}
        >
          <span
            className={`${
              router.pathname.includes('free-for-subscribers') ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-a-blue transition`}
          />
        </Switch>
      </Link>
      <Link
        href="/collections/free-for-subscribers"
        className={
          router.pathname.includes('free-for-subscribers') ? 'text-a-blue font-medium' : ''
        }
      >
        Free with AVFX+
      </Link>
    </div>
  );
};

export default FreeCollectionsSwitch;
